import store from "@/store";
import {
  getModule,
  Module,
  Mutation,
  MutationAction,
  VuexModule,
  Action,
} from "vuex-module-decorators";
import { LoginModel } from "@/models/login/LoginModel";
import { LoginResponseDTO } from "@/api/auth/LoginResponseDTO";
import { usuarioService } from "@/service/usuario/UsuarioService";
import { usuarioStorage } from "./UsuarioStorage";
import { AlterarSenhaModel } from "@/models/login/AlterarSenhaModel";

export interface IUsuarioModule {
  authData: LoginResponseDTO;
}

const getDefaultState = () => {
  return {
    authData: null,
  };
};

@Module({
  namespaced: true,
  dynamic: true,
  store,
  name: "usuario",
})
class UsuarioModule extends VuexModule {
  public authData: LoginResponseDTO | null = null;

  get token() {
    return this.authData ? this.authData : usuarioStorage.getData();
  }

  get hasToken() {
    return !!this.authData || !!usuarioStorage.getData();
  }

  @Mutation
  RESET() {
    Object.assign(this, getDefaultState());
    usuarioStorage.deleteData();
  }

  @Mutation
  SET_AUTH_DATA(payload: LoginResponseDTO | null) {
    this.authData = payload;
  }

  @MutationAction({ mutate: ["authData"], rawError: true })
  async checkUser() {
    if (this.authData) {
      return {
        authData: this.authData,
      };
    }

    const data = usuarioStorage.getData();
    if (!data) {
      throw Error("Usuario não logado.");
    }
    const authData = await usuarioService.atualizarToken({
      refreshToken: usuarioStorage.getLocalRefreshToken() || "",
    });
    return {
      authData
    };
  }

  @MutationAction({ mutate: ["authData"] })
  async efetuarLogin(loginModel: LoginModel) {
    const authData = await usuarioService.efetuarLogin(loginModel);
    usuarioStorage.setData(authData);
    return {
      authData,
    };
  }

  @MutationAction({ mutate: ["authData"] })
  async refreshToken() {
    const authData = await usuarioService.atualizarToken({
      refreshToken: usuarioStorage.getLocalRefreshToken() || "",
    });
    usuarioStorage.setData(authData);
    return {
      authData,
    };
  }

  @MutationAction({ mutate: ["authData"], rawError: true })
  async logout() {
    usuarioStorage.deleteData();
    const authData = getDefaultState();
    return {
      authData,
    };
  }

  @Action({ rawError: true })
  alterarSenha(senha: AlterarSenhaModel) {
    return usuarioService.alterarSenha(usuarioStorage.username, senha);
  }
}

const usuarioModule = getModule(UsuarioModule);
export default usuarioModule;
